import React from 'react';
import { Badge } from '../ui/badge';

/**
 * Header row above the chart: strategy name, description, category badges,
 * timeframe, risk, style, and the score badge tinted to the strategy color.
 */
const StrategyHeader = ({ strategy, color }) => (
  <div className="flex items-center justify-between">
    <div>
      <p className="text-sm font-semibold">{strategy.name}</p>
      <p className="text-xs text-gray-500 mt-1">{strategy.description}</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {strategy.category && (
          <Badge variant="outline" className="text-[10px] uppercase tracking-wide">
            {strategy.category}
          </Badge>
        )}
        {strategy.timeframe && (
          <Badge variant="outline" className="text-[10px] uppercase tracking-wide">
            {strategy.timeframe} term
          </Badge>
        )}
        {strategy.risk_level && (
          <Badge variant="outline" className="text-[10px] uppercase tracking-wide">
            Risk: {strategy.risk_level.replace('_', ' ')}
          </Badge>
        )}
        {strategy.style && (
          <Badge variant="outline" className="text-[10px] uppercase tracking-wide">
            {strategy.style.replace('_', ' ')}
          </Badge>
        )}
      </div>
    </div>
    <Badge style={{ backgroundColor: color }} className="text-white">
      {strategy.score}/100
    </Badge>
  </div>
);

export default StrategyHeader;
